import React, { useState } from 'react';
import {
    FacebookShareButton,
    WhatsappShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    FacebookIcon,
    WhatsappIcon,
    LinkedinIcon,
    TwitterIcon
} from "react-share";
import './ShareButton.scss'

const ShareButton = ({ link }) => {
    const [showIcon, setShowIcon] = useState(false);
    return (
        <div className='share-social'>
            <i onClick={() => { setShowIcon(!showIcon) }} className={showIcon ? "bi bi-x-lg" : "bi bi-share-fill"} />
            <div className={`share-social-button ${showIcon ? 'active' : null}`}>
                <FacebookShareButton url={link}>
                    <FacebookIcon size={32} />
                </FacebookShareButton>
                <WhatsappShareButton url={link}>
                    <WhatsappIcon size={32} />
                </WhatsappShareButton>
                <LinkedinShareButton url={link}>
                    <LinkedinIcon size={32} />
                </LinkedinShareButton>
                <TwitterShareButton url={link}>
                    <i className="fa-brands fa-x-twitter twitter"></i>
                </TwitterShareButton>
            </div>
        </div>
    )
}
export default ShareButton;